import { autobind } from "core-decorators";
import { Inject } from "typescript-ioc";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { DeliveryChannel } from "./DeliveryChannel";
import { IChannelUpdateEvent } from "./IChannelUpdateEvent";
import { IDeliveryChannelModel } from "./IDeliveryChannelModel";

export class DefaultDeliveryChannel extends DeliveryChannel {
    public static readonly templateId: string = "default-delivery-method-template";

    public get key(): string {
        return "DefaultDeliveryChannel";
    }

    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    public init(): void {
        if (this._model.SelectedDeliveryChannel === this._model.DeliveryChannelId) {
            this._makeChannelSelected();
        }
        this._bindEvents();
        this._handleOutOfStockTooltip(this._model.OutOfStockItems, this._model.DeliveryChannelId);
        this._handleUnsupportedAddressTooltip(this._model.DeliveryChannelId);
        this._toggleChannelSelectability(this.model);
    }

    private _bindEvents(): void {
        this.bindClick(this._handleClick);
    }

    @autobind
    private _handleClick(event: IChannelUpdateEvent): void {
        if (this._isClickOnChannel(event)) {
            this._triggerChannelUpdate({
                deliveryAddress: this._model.IsHomeDelivery
                    ? this._model.LastUsedDeliveryAddressId
                    : null,
                deliveryChannel: this._model.DeliveryChannelId,
            });
        }
    }

    public update(nextState: IDeliveryChannelModel): void {
        const wasComponentUpdated = this._updateFromDeliveryModel(this._model, nextState, false);

        if (wasComponentUpdated) {
            const isOutOfStockChanged = this._wasOutOfStockItemsChanged(
                this._model.OutOfStockItems,
                nextState.OutOfStockItems
            );
            const isDeliveryDateChanged = this._isChanged(
                this._model.DeliveryDate,
                nextState.DeliveryDate
            );
            const isEndCustomerAddressChanged =
                this._isEndCustomerFirstCheckout() &&
                this._isChanged(this._model.Address, nextState.Address);

            if (isOutOfStockChanged || isDeliveryDateChanged || isEndCustomerAddressChanged) {
                this._updateAddressInfo(nextState);
            }

            this._model = nextState;
        }
    }
}
